/* assets/ornaments.js — ONE-FLOW (custom ATC only), file uploads to Shopify, shows filename */

// ==========================
// 0) Image → circular preview
// ==========================
(function () {
  if (window.__ornamentInit) return; window.__ornamentInit = true;

  const fileInput   = document.getElementById('ornament-file');   // <input type="file" id="ornament-file">
  const previewWrap = document.querySelector('.orn-preview-wrap'); // optional container you already have
  const canvas      = document.getElementById('ornament-canvas');  // <canvas id="ornament-canvas">
  const ctx         = canvas ? canvas.getContext('2d') : null;

  window.__ORNAMENT__ = window.__ORNAMENT__ || { imageData: '' };

  function drawCircular(img) {
    if (!ctx || !canvas) return;
    const W = 800, H = 800;
    canvas.width = W; canvas.height = H;

    // cover logic
    const iw = img.naturalWidth, ih = img.naturalHeight;
    const ir = iw/ih, cr = W/H;
    let dw, dh, dx, dy;
    if (ir > cr) { // wider
      dh = H; dw = H * ir; dx = (W - dw) / 2; dy = 0;
    } else {       // taller
      dw = W; dh = W / ir; dx = 0; dy = (H - dh) / 2;
    }

    // white background
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, W, H);

    // circular clip
    ctx.save();
    ctx.beginPath();
    ctx.arc(W/2, H/2, Math.min(W,H)/2, 0, Math.PI * 2);
    ctx.closePath();
    ctx.clip();

    // draw image
    ctx.drawImage(img, dx, dy, dw, dh);
    ctx.restore();

    // subtle rim
    ctx.beginPath();
    ctx.arc(W/2, H/2, Math.min(W,H)/2 - 3, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(0,0,0,0.06)';
    ctx.lineWidth = 6;
    ctx.stroke();

    // compressed preview (kept as line-item text for quick checking)
    window.__ORNAMENT__.imageData = canvas.toDataURL('image/jpeg', 0.72);
  }

  function handleFile(file) {
    if (!file) return;
    const img = new Image();
    img.onload = () => {
      drawCircular(img);
      if (previewWrap) previewWrap.style.display = 'block';
      document.dispatchEvent(new CustomEvent('ornament:image-ready'));
    };
    const reader = new FileReader();
    reader.onload = e => { img.src = e.target.result; };
    reader.readAsDataURL(file);
  }

  if (fileInput) {
    // allow reselecting the same file
    fileInput.addEventListener('click', function(){ this.value = ''; }, { passive: true });
    fileInput.addEventListener('change', function(){
      handleFile(this.files && this.files[0]);
    }, { passive: true });
  }
})();


// =====================================
// 1) Shared helpers (pack + multipart)
// =====================================
(function () {
  function getFileInput() {
    return document.getElementById('ornament-file');
  }
  function getSelectedPack() {
    const packSelect = document.getElementById('orn-pack'); // <select id="orn-pack"> with data-price attrs
    if (!packSelect) return null;
    const id = Number(packSelect.value || 0);
    if (!id) return null;
    const opt   = packSelect.options[packSelect.selectedIndex];
    const price = Number(opt.getAttribute('data-price') || 0);
    const title = opt.getAttribute('data-title') || opt.textContent || '';
    return { id, price, title, label: opt.textContent || title };
  }

  async function postMultipart(variantId, packLabel, artDataUrl) {
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    if (packLabel) fd.append('properties[Pack]', packLabel);
   

    // Add the REAL file → Shopify uploads to CDN and stores URL in property
    const fi = getFileInput();
    const file = fi && fi.files && fi.files[0];
    if (file) {
      fd.append('properties[Artwork URL]', file);   // becomes a clickable CDN URL
      fd.append('properties[Artwork name]', file.name); // show the original filename
      // Optional extras:
      // fd.append('properties[Artwork size]', Math.round(file.size/1024) + ' KB');
      // fd.append('properties[Artwork type]', file.type || '');
    }

    // IMPORTANT: /cart/add (no .js) to allow multipart; browser sets boundary
    await fetch('/cart/add', { method: 'POST', body: fd, credentials: 'same-origin' });
  }

  window.__ORN_HELPERS__ = { getSelectedPack, postMultipart };
})();


// ===================================================
// 2) Custom ATC (SINGLE FLOW) — disables double adds
// ===================================================
(function () {
  const atcBtn  = document.getElementById('orn-atc');   // <button id="orn-atc">
  const totalEl = document.getElementById('orn-total'); // optional price text

  // Make sure clicking this button does NOT submit any form
  if (atcBtn) atcBtn.setAttribute('type', 'button');

  // UI refresh: enable only when we have art + a pack
  function refreshUI() {
    const hasArt = !!(window.__ORNAMENT__ && window.__ORNAMENT__.imageData);
    const pack   = window.__ORN_HELPERS__.getSelectedPack();
    const price  = pack ? pack.price : 0;

    if (totalEl) totalEl.textContent = `Total: $${price.toFixed(2)}`;
    if (atcBtn) {
      const ok = hasArt && !!pack;
      atcBtn.disabled = !ok;
      atcBtn.style.cursor = ok ? 'pointer' : 'not-allowed';
      atcBtn.style.opacity = ok ? '1' : '.45';
    }

    const wrap = document.querySelector('.orn-preview-wrap');
    if (wrap) wrap.style.display = hasArt ? 'block' : 'none';
  }
  document.addEventListener('ornament:image-ready', refreshUI);
  const packSelect = document.getElementById('orn-pack');
  if (packSelect) packSelect.addEventListener('change', refreshUI);
  refreshUI();

  // Single-flight guard so it can't double-add
  let ORN_BUSY = false;

  if (atcBtn) {
    atcBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (ORN_BUSY) return;

      const art  = (window.__ORNAMENT__ && window.__ORNAMENT__.imageData) || '';
      const pack = window.__ORN_HELPERS__.getSelectedPack();
      if (!pack) { alert('Please select a pack.'); return; }
      if (!art)  { alert('Please upload your image/design.'); return; }

      ORN_BUSY = true;
      try {
        await window.__ORN_HELPERS__.postMultipart(pack.id, pack.label, art);

        // Optional drawer
        if (typeof openATCDrawer === 'function') {
          openATCDrawer([{
            title: window.__ORN_PRODUCT_TITLE__,
            image: window.__ORN_PRODUCT_IMAGE__,
            price: pack.price,
            qty: 1
          }]);
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('ATC failed:', err);
        alert('Could not add to cart. Please try again.');
      } finally {
        ORN_BUSY = false;
      }
    });
  }
})();


// ===================================================
// 3) (Optional) Sale banner you already had
// ===================================================
(function(){
  var b=document.getElementById('orn-sale'); if(!b) return;
  var P=b.querySelector('.mm-pct'), N=b.querySelector('.mm-sale-now'), W=b.querySelector('.mm-sale-was');
  var V=window.__ORN_VARIANTS__||[];
  function money(c){try{if(window.Shopify&&Shopify.formatMoney)return Shopify.formatMoney(c, window.Shopify.money_format||"{{ shop.money_format | escape }}");}catch(e){} return (c/100).toLocaleString(undefined,{style:'currency',currency:'{{ shop.currency }}'});}
  function update(id){var v=V.find(function(x){return String(x.id)===String(id)}); if(!v) return;
    var p=v.price, c=v.compare_at_price; if(!c||c<=p){b.style.display='none';return;}
    var pct=Math.round((c-p)*100/c); if(P)P.textContent=pct; if(N)N.textContent=money(p); if(W)W.textContent='Was '+money(c); b.style.display='';}
  var sel=document.querySelector('select[name="id"]'); if(sel){sel.addEventListener('change',function(){update(this.value)}); update(sel.value || (V[0]&&V[0].id));}
  document.addEventListener('variant:change',function(e){e.detail&&e.detail.variant&&update(e.detail.variant.id);});
})();

document.addEventListener('DOMContentLoaded', function () {
  const variants = window.__ORN_VARIANTS__ || [];
  if (!variants.length) return;

    const packSelect    = document.getElementById('orn-pack');          // our custom Packs dropdown
  const variantSelect = document.querySelector('select[name="id"]');  // hidden Shopify variant select

  // If this page has our custom pack selector, hide the VISIBLE Shopify option dropdown(s)
  // (this runs only on ornaments, because mugs don't have #orn-pack).
  if (packSelect) {
    const inputs = document.querySelectorAll('.product-form__input');
    inputs.forEach(input => {
      // Don't hide anything that contains our custom pack select
      if (input.contains(packSelect)) return;

      // This finds the visible Shopify option dropdown like "Packs"
      if (
        input.querySelector('select[name^="options["]') ||
        input.querySelector('select[id^="Option-"]') ||
        input.querySelector('select[data-index^="option"]')
      ) {
        input.style.display = 'none';
      }
    });
  }


  // --- Build the sale banner (same look as before) ---
  const banner = document.createElement('div');
  banner.id = 'orn-sale';
  banner.className = 'mm-sale-info';
  banner.innerHTML = `
    <span class="mm-sale-badge"><span class="mm-pct">0</span>% OFF</span>
    <span class="mm-sale-ends">ENDS SOON</span>
    <span class="mm-sale-now">$0.00</span>
    <span class="mm-sale-was">Was $0.00</span>
  `;

  const style = document.createElement('style');
  style.textContent = `
    .mm-sale-info{margin:12px 0 6px;display:flex;flex-wrap:wrap;align-items:center;gap:10px;font-weight:700}
    .mm-sale-badge{padding:6px 10px;border-radius:999px;background:rgba(255,0,120,.08);border:1px solid rgba(255,0,120,.22);box-shadow:inset 0 1px 0 rgba(255,255,255,.75);font-weight:800;white-space:nowrap;color:#ff0078}
    .mm-sale-ends{color:#ff0078;font-weight:800;letter-spacing:.2px;animation:pulsePink 1.8s infinite}
    .mm-sale-now{font-size:1.65rem;font-weight:900}
    .mm-sale-was{color:#666;text-decoration:line-through;font-weight:600}
    @keyframes pulsePink{0%,100%{opacity:1}50%{opacity:.6}}
  `;
  document.head.appendChild(style);

  // Prefer to anchor the banner to our pack dropdown; fall back to Shopify variant select
  const ref = packSelect || variantSelect;
  if (ref && ref.parentNode) {
    const section = ref.closest('.product-form, form, .ornament-block, div');
    if (section && section.parentNode) {
      section.parentNode.insertBefore(banner, section);
    } else {
      ref.parentNode.insertBefore(banner, ref);
    }
  } else {
    document.body.prepend(banner);
  }

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.Shopify.money_format || "${{amount}}");
      }
    } catch (e) {}
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  }

  function updateByVariantId(id) {
    const v = variants.find(x => String(x.id) === String(id)) || variants[0];
    if (!v || !v.compare_at_price || v.compare_at_price <= v.price) {
      banner.style.display = 'none';
      return;
    }
    const pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
    banner.querySelector('.mm-pct').textContent = pct;
    banner.querySelector('.mm-sale-now').textContent = money(v.price);
    banner.querySelector('.mm-sale-was').textContent = 'Was ' + money(v.compare_at_price);
    banner.style.display = 'flex';
  }

  // If we have our custom pack dropdown, use that for updates.
  // Otherwise, fall back to the Shopify variant select.
  if (packSelect) {
    packSelect.addEventListener('change', function () {
      updateByVariantId(this.value);
    });
    updateByVariantId(packSelect.value || (variants[0] && variants[0].id));
  } else if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      updateByVariantId(this.value);
    });
    updateByVariantId(variantSelect.value || (variants[0] && variants[0].id));
  }
});


/* Ornaments: move accordion under ATC and (re)initialize once */
(function () {
  function initAccordion(root) {
    if (!root || root.dataset.mmAccInit === '1') return;
    root.dataset.mmAccInit = '1';

    // Find all triggers
    const titles = Array.from(root.querySelectorAll('.acc-title'));
    if (!titles.length) return;

    // Helper: close all except optional "except"
    function closeAll(except) {
      titles.forEach(t => {
        const isExcept = (t === except);
        t.classList.toggle('open', !!isExcept);
        t.setAttribute('aria-expanded', isExcept ? 'true' : 'false');

        const pane = t.nextElementSibling;
        if (pane) {
          pane.style.display = isExcept ? 'block' : 'none';
          pane.setAttribute('aria-hidden', isExcept ? 'false' : 'true');
        }
      });
    }

  

    // Click + keyboard toggle
    titles.forEach(title => {
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.addEventListener('click', () => {
        const isOpen = title.classList.contains('open');
        closeAll(isOpen ? null : title);
      });
      title.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); title.click(); }
      });
    });
  }

  function moveAndInit() {
    const atc = document.getElementById('orn-atc');
    const acc =
      document.getElementById('ornament-accordion') ||
      document.querySelector('.acc--compact') ||
      document.querySelector('.acc');

    if (!acc) return;

    // Move it under ATC once (avoid re-parenting loops)
    if (atc && acc && acc.previousElementSibling !== atc) {
      atc.insertAdjacentElement('afterend', acc);
    }

    initAccordion(acc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveAndInit);
  } else {
    moveAndInit();
  }

  // In case something changes the DOM later, you can call window.mmAccRefresh()
  window.mmAccRefresh = moveAndInit;
})();
